import { render, staticRenderFns } from "./PatentDivisionList.vue?vue&type=template&id=029f2d01&"
import script from "./PatentDivisionList.vue?vue&type=script&lang=js&"
export * from "./PatentDivisionList.vue?vue&type=script&lang=js&"
import style0 from "./PatentDivisionList.vue?vue&type=style&index=0&id=029f2d01&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports